import { MxGraphCircle } from './icons/mxGraphCircle';

export type ItemsToSellType = {
  percent: number;
  name: string;
  Icon: JSX.Element;
};

const ItemsToSellCard = ({ percent, name, Icon }: ItemsToSellType) => {
  return (
    <div className="flex-1">
      <div className="flex h-full flex-col  items-center border-2 border-brand-lighter-gray p-[4rem]">
        {Icon}
        <div className="text-[2.4rem] font-semibold">{name}</div>
        <MxGraphCircle className="mb-[2rem] mt-[4rem]" percent={percent} />
      </div>
    </div>
  );
};

export default ItemsToSellCard;
